import React from 'react';
import Header from '../../Header';
import Navbar from '../../Navbar';
import Footers from '../../Footers';
import NewsletterSection from '../../NewsletterSection';
import './Contact.css';


export default function Contact() {
    return (
        <div>
            <Header />
            <Navbar />
            <div className="contact-section">
                <div className="contact-heading">
                    <h1>Say Hello to us!</h1>
                    <p className='content-para'>Have any concerns regarding our products or want to drop a message? Our team would be happy to help you</p>
                    <p className='content-para'>Covering all your queries ranging from bulk orders to a single one.</p>
                </div>
                <div className="contact-wrapper">
                    {/* Contact Info */}
                    <div className="contact-left">
                        <p className="contact-text">
                            Have a doubt or any concern? Contact us today to get it resolved
                        </p>

                        <div className="contact-block">
                            <p><strong>Phone or Whatsapp:</strong> +91 --------</p>
                            <p><strong>Email:</strong>-------------------------</p>
                        </div>

                        <div className="contact-block">
                            <p className="contact-title">CORPORATE OFFICE</p>
                            <p>----------------------------------------------</p>
                        </div>
                    </div>

                    {/* Contact Form */}
                    <form className="contact-form">
                        <input type="text" placeholder="Name *" required />
                        <input type="email" placeholder="Email *" required />
                        <textarea placeholder="Message *" rows="4" required></textarea>
                        <button type="submit">Send</button>
                    </form>
                </div>
            </div>
            <NewsletterSection />
            <Footers />
        </div>
    );
}
